////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskImplantation = {
	[ActionsTypes.POST_KIOSK_IMPLANTATION]: (state) =>
		update(state, {
			columns: {
				isEditingTrigger: {
					$set: false,
				},
				isSearchfieldUpdated: {
					$set: false,
				},
			},
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				initKioskImplantation: {
					data: {
						headerContent: {
							contentPagined: {
								content: {
									$set: [],
								},
							},
						},
					},
					isUpdate: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_IMPLANTATION_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				initKioskImplantation: {
					data: {
						$set: payload.data,
					},
					// storedDatas var also needs to be cleared
					storedDatas: {
						$set: [],
					},
				},
				statusId: {
					$set: payload.data.headerParam.progressInfo.statusId,
				},
				requestId: {
					$set: payload.id,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_IMPLANTATION_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.GET_ITEMS_CATALOG_GROWTH]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				initKioskImplantation: {
					catalog: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_ITEMS_CATALOG_GROWTH_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				initKioskImplantation: {
					catalog: {
						$set: payload.data,
					},
				},
			},
		})
	},
	[ActionsTypes.GET_ITEMS_CATALOG_GROWTH_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_UNIT_ACTION_WITH_ID]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				initKioskImplantation: {
					isUpdate: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.PUT_UNIT_ACTION_WITH_ID_SUCCESS]: (state, payload) => {
		const dataCp = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.initKioskCreation.initKioskImplantation.data)

		dataCp.forEach((elem, key) => {
			const idx = findIndex(stateCp.headerContent.contentPagined.content, (e) => e.id === elem.id)
			if (idx > -1) {
				stateCp.headerContent.contentPagined.content[idx] = elem
			}
		})
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				initKioskImplantation: {
					data: {
						$set: stateCp,
					},
					isUpdate: {
						$set: true,
					},
				},
			},
		})
	},
	[ActionsTypes.PUT_UNIT_ACTION_WITH_ID_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_VALIDATE_IMPLANTATION]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.PUT_VALIDATE_IMPLANTATION_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				initKioskImplantation: {
					data: {
						$set: payload,
					},
				},
			},
		})
	},
	[ActionsTypes.PUT_VALIDATE_IMPLANTATION_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_IMPLANTATION]: (state, _payload) =>
		update(state, {
			initKioskCreation: {
				statusId: {
					$set: 0,
				},
				requestId: {
					$set: null,
				},
				error: {
					$set: false,
				},
				initKioskImplantation: {
					availableOptions: {
						$set: {},
					},
					data: {
						$set: {
							headerContent: {
								contentPagined: {
									content: [],
								},
							},
						},
					},
					isEditable: {
						$set: true,
					},
				},
				forceReadOnly: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.RESET_ERROR_IMPLANTATION]: (state, _payload) =>
		update(state, {
			initKioskCreation: {
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SET_STORED_DATAS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				initKioskImplantation: {
					storedDatas: {
						$set: payload.arr,
					},
				},
			},
		})
	},
}

export default initKioskImplantation
